import React, { useMemo, useRef, useState } from 'react';
import {
  Box,
  ChevronDownIcon,
  ChevronUpIcon,
  Option,
  OptionKey,
  RawButton,
  Text,
  useClickOutside,
} from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

const StyledText = styled(Text)``;
const StyledWrapper = styled(Box)``;
const StyledButtonWrapper = styled(RawButton)`
  ${({ theme }) => {
    return css`
      &:hover {
        ${StyledWrapper} {
          background: ${theme.colors.buttonTertiaryHover};
        }
      }
    `;
  }}
`;

interface Props {
  options: Option[];
  value: OptionKey;
  onChange: (value: OptionKey) => void;
}
const PlanYearPicker: React.FC<Props> = ({ options, value, onChange }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);
  const currentItem = useMemo(() => {
    return options.find((option) => option.key === value);
  }, [options, value]);

  const handleOptionClick = (option: Option) => {
    onChange(option.key);
    setExpanded(false);
  };
  const ref = useRef(null);
  useClickOutside(ref, () => {
    setExpanded(false);
  });
  return (
    <Box ref={ref} style={{ position: 'relative' }}>
      <RawButton onClick={handleToggle}>
        <Box direction="row" align="center" justify="end" width={{ min: '230px', max: '230px' }}>
          <Text color="textAccent">{`${currentItem?.title || currentItem?.value}`}</Text>
          <Box direction="row">{expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}</Box>
        </Box>
      </RawButton>
      <Box style={{ position: 'absolute', top: '100%', right: '0' }}>
        {expanded && (
          <Box
            background="canvas"
            round="container2Round"
            elevation="active"
            pad="spacing12"
            height={{ max: '400px' }}
            overflow="auto"
            width={{ min: '230px', max: '230px' }}
            style={{ zIndex: 100 }}
          >
            {options.map((option) => (
              <StyledButtonWrapper
                key={option.key}
                value={option.key}
                onClick={() => handleOptionClick(option)}
              >
                <StyledWrapper
                  pad={{ vertical: 'spacing4', horizontal: 'spacing8' }}
                  height={{ min: '32px' }}
                  round="button2Round"
                >
                  <StyledText
                    color={option.key === value ? 'textAccent' : 'textBody'}
                    size="medium"
                    weight={option.key === value ? 700 : 400}
                    truncate
                    title={`${option.title || option.value}`}
                  >
                    {`${option.title || option.value}`}
                  </StyledText>
                </StyledWrapper>
              </StyledButtonWrapper>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PlanYearPicker;
